import { Box, Typography } from '@mui/material';
import React from 'react';
import Faq from '../components/Faq';
import Layout from '../components/Layout';
import SecondPageLayout from '../components/Layout/SecondPageLayout';

const FaqPage = () => {
    return (
        <SecondPageLayout withFooter={true}>
            <Box sx={{display:'flex', gap:'5px'}}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Component 2">
                    <path
                        id="Icon"
                        d="M10.4996 9.00224C10.6758 8.50136 11.0236 8.079 11.4814 7.80998C11.9391 7.54095 12.4773 7.4426 13.0006 7.53237C13.524 7.62213 13.9986 7.89421 14.3406 8.30041C14.6825 8.70661 14.8697 9.22072 14.8689 9.75168C14.8689 11.2506 12.6205 12 12.6205 12M12.6495 15H12.6595M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z"
                        stroke="#2F4B6C"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    </g>
                </svg>
                <Typography color='#154D72' fontSize={'20px'} fontWeight={700} lineHeight={'28px'}>
                    שאלות נפוצות
                </Typography>
            </Box>
            <Faq.Filter/>
            <Faq.List/>
            <Faq.Info/>
        </SecondPageLayout>
    );
};

export default FaqPage;